import { z } from "zod";

export const UpdateProfileResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.object({
        id: z.string().uuid(),
        name: z.string(),
        email: z.string().email(),
        email_verified_at: z.nullable(z.string()), // ISO date string or null
        created_at: z.string(), // ISO date string
        updated_at: z.string(), // ISO date string
        channex_user_api_key: z.nullable(z.string()).optional(),
        username: z.nullable(z.string().optional()),
        phone: z.nullable(z.string()),
    }),
});

export type UpdateProfileResponseType = z.infer<typeof UpdateProfileResponse>;